import React from 'react';
import CustomQuestionText from './CustomQuestionText';
import CustomQuestionInteger from './CustomQuestionInteger';
import CustomQuestionCheckbox from './CustomQuestionCheckbox';
import CustomQuestionRadio from './CustomQuestionRadio';
import { ReportCustomQuestionTypePropsBase } from './utils';

type ReportCustomQuestionTypeProps = ReportCustomQuestionTypePropsBase

const ReportCustomQuestionType: React.FC<ReportCustomQuestionTypeProps> = props => {
  switch (props.question.questionType) {
    case 'text':
    case 'comment':
      return <CustomQuestionText {...props} />;
    case 'integer':
      return <CustomQuestionInteger {...props} />;

    // case 'multi-text':
    // case 'multi-integer':
    //   return <CustomQuestionComment {...props} />;
    // case 'matrix-dropdown':
    //   return <CustomQuestionComment {...props} />;

    case 'checkbox':
      return <CustomQuestionCheckbox {...props} />;
    case 'dropdown':
    case 'radio-group':
      return <CustomQuestionRadio {...props} />;

    default:
    case 'guidance':
      return null;
  }
};

export default ReportCustomQuestionType;
